import { Component } from 'react';
import { apiGetFileP } from '../../GanjiTools';
import SelectQueryBuilder from '../SelectQueryBuilder';
import CollapsibleDefault from './CollapsibleDefault';

const operators = [
    { val: '=', text: 'مساوی با', nature: 'number/text/list/tarikh', n: 1 },
    { val: '<>', text: 'نامساوی با', nature: 'number/text/list/tarikh', n: 1 },
    { val: 'one_of', text: 'یکی از', nature: 'list', n: 1 },
    { val: 'none_of', text: 'هیچکدام از', nature: 'list', n: 1 },
    { val: 'in_range', text: 'در بازه', nature: 'number/tarikh', n: 2 },
    { val: 'out_range', text: 'خارج از بازه', nature: 'number/tarikh', n: 2 },
    { val: '>', text: 'بزرگتر از', nature: 'number/tarikh', n: 1 },
    { val: '<', text: 'کوچکتر از', nature: 'number/tarikh', n: 1 },
    { val: '>=', text: 'بزرگتر یا مساوی', nature: 'number/tarikh', n: 1 },
    { val: '<=', text: 'کوچکتر یا مساوی', nature: 'number/tarikh', n: 1 }
]

class ExportTool extends Component {

    state = {
        //loading: true,
        //width: this.props.width,
    }

    onExportToExcel = op => {
        op ??= { fieldEqualities: [] };
        let xFieldEqualities = !this.props.extraFieldEqualities ? []
            : Array.isArray(this.props.extraFieldEqualities) ? this.props.extraFieldEqualities
                : [this.props.extraFieldEqualities];

        op.fieldEqualities ??= [];
        op.fieldEqualities.push(...xFieldEqualities);

        apiGetFileP(`/api/dyna/exportToExcel/${this.props.table}?selectCommandJsn=${encodeURIComponent(JSON.stringify(op))}`,
            (this.props.fileName ?? `${this.props.table}_report`) + ".xlsx")
            .then(res => {
                if (res?.error?.length > 0) {
                    window.notif(res.error);
                    return;
                }
                console.log('ok. the file is downloaded.');
            })
            .catch(window.notif);
    }

    componentDidMount() {
    }

    render() {
        let width = this.props.width;
        return (
            <CollapsibleDefault title='خروجی به فایل' width={width} >
                <SelectQueryBuilder table={this.props.table} width={`calc(${width} - 3rem)`}
                    excludeFields={this.props.excludeFields}
                    onRunQuery={this.onExportToExcel}
                    runButtonText='خروجی به اکسل'
                />
            </CollapsibleDefault>
        )
    }
}

export default ExportTool;